module.exports = __webpack_public_path__ + "media/images/referrals/green-stars-5-27f94caa0ce60c253acc54ed52f92893.svg";